import React, { useEffect } from "react";
import { PageHeader, MyTextInput } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// material ui
import {
  Card,
  CardHeader,
  IconButton,
  Grid,
  Box,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import { FormSubmitButton, CommonCurdPopUp } from "../../../../components";
import Notifier from "../../../../components/common/Notifier";
import ErrorNotifier from "../../../../components/common/ErrorNotifier";
// redux
import {
  updateRolesChr,
  getRolesChr,



  resetMessage,
  resetErrMessage,
} from "../../../../features/iam_chr/role_management/rolesSlice";
import { getUserGroupsChr } from "../../../../features/iam_chr/role_management/userGroupsSlice";

// --------------------------------------------------------------

const validationSchema = Yup.object({
  userGroup: Yup.string().uuid().required("User Group is required"),
  roleCode: Yup.string().matches(/\S/, "Role Code cannot be just white spaces").required("Role Code is required").min(2, "Role Code must be at least 2 characters")
    .max(4, "Role Code must not exceed 4 characters"),
  roleName: Yup.string().matches(/\S/, "Role Name cannot be just white spaces").required("Role Name is required"),
  securityLevel: Yup.number().required("Security Level is required"),
  roleDesc: Yup.string().matches(/\S/, "Role Description cannot be just white spaces").required("Role Description is required"),
});

//   ------------------------------------------------------------------------------------------

const UpdateRoles = (props) => {
  const { message, errMessage, rolesSelectedData,loading } = useSelector(
    (state) => ({ ...state.rolesChr })
  );
  const { userGroupsData } = useSelector((state) => ({ ...state.userGroupsChr }));

  const dispatch = useDispatch();

  console.log(rolesSelectedData)

  const formik = useFormik({
    initialValues: {
      userGroup: rolesSelectedData?.userGroupChr?.id,
      roleCode: rolesSelectedData?.roleCode,
      roleName: rolesSelectedData?.roleName,
      securityLevel: rolesSelectedData?.securityLevel,
      roleDesc: rolesSelectedData?.roleDescription,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const res = await dispatch(
        updateRolesChr({
          id: rolesSelectedData.id,
          userGroupChrId: values?.userGroup,
          roleCode: values?.roleCode,
          roleName: values.roleName,
          securityLevel: values?.securityLevel,
          roleDescription: values.roleDesc,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            props.close();
            dispatch(getRolesChr());
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });

  useEffect(() => {
    dispatch(getUserGroupsChr())
  }, [])

  const handleSubmit = async () => {
    const result = await formik.submitForm();
    return result;
  };

  return (
    <>

      {props?.showEdit && <CommonCurdPopUp
        heading={`Update Role`}
        mediumScreen={true}
        close={props.close}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11} >

            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Group Name *
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="userGroup"
                value={formik.values.userGroup}
                error={
                  formik.touched.userGroup && Boolean(formik.errors.userGroup)
                }
                label="userGroup"
                onChange={formik.handleChange}
              >
                {userGroupsData.length > 0 &&
                  userGroupsData.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.groupName}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formik.touched.userGroup && formik.errors.userGroup}
              </FormHelperText>
            </FormControl>
            <MyTextInput
              label="Role Code"
              type="text"
              name="roleCode"
              required={true}
              fullWidth={true}
              margin="normal"
              id="roleCode"
              value={formik.values.roleCode}
              onChange={formik.handleChange}
              error={
                formik.touched.roleCode && Boolean(formik.errors.roleCode)
              }
              helperText={formik.touched.roleCode && formik.errors.roleCode}
            />
            <MyTextInput
              label="Role Name"
              type="text"
              name="roleName"
              required={true}
              fullWidth={true}
              margin="normal"
              id="roleName"
              value={formik.values.roleName}
              onChange={formik.handleChange}
              error={
                formik.touched.roleName && Boolean(formik.errors.roleName)
              }
              helperText={formik.touched.roleName && formik.errors.roleName}
            />
            <MyTextInput
              label="Security Level"
              type="number"
              name="securityLevel"
              fullWidth={true}
              required={true}
              margin="normal"
              id="securityLevel"
              value={formik.values.securityLevel}
              onChange={formik.handleChange}
              error={
                formik.touched.securityLevel && Boolean(formik.errors.securityLevel)
              }
              helperText={formik.touched.securityLevel && formik.errors.securityLevel}
            />
            <MyTextInput
              label="Role Description"
              type="text"
              name="roleDesc"
              fullWidth={true}
              margin="normal"
              id="roleDesc"
              value={formik.values.roleDesc}
              onChange={formik.handleChange}
              required={true}
              error={
                formik.touched.roleDesc && Boolean(formik.errors.roleDesc)
              }
              helperText={formik.touched.roleDesc && formik.errors.roleDesc}
            />
            {/* <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
          </Grid>
        </Grid>



      </CommonCurdPopUp>}
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}

    </>
  );
};

export default UpdateRoles;
